import { observable } from 'mobx';

export class CoachingTip {
  @observable public text?: string;
  @observable public image?: string;

  constructor(text?: string, image?: string) {
    this.text = text;
    this.image = image;
  }
}

export default CoachingTip;



// WEBPACK FOOTER //
// ./src/app/models/CoachingTip.ts